import styled from 'styled-components';
import { getIcon } from 'styles/icons';
import { getColor, type Theme } from 'styles/theme';

export const IconSocialShareDropdownWrapper = styled.div<{ theme: Theme; $showSocials: boolean }>`
  width: fit-content;
  position: relative;  

  &::before {
    ${getIcon('share-icon')};
    margin: 0 8px 0px 8px;
  }

  ul {
    top: 36px;
    position: absolute;
    background-color: ${getColor('surfaceWhite')};  
    ${(props) => (props.$showSocials ? { display: 'inline-block' } : { display: 'none' })}
    border: 1px solid ${getColor('borderPrimary')};
    border-radius: 4px;
    padding: 8px;
      
    li {
      margin: 0;
      &:not(:first-of-type) {
        margin-top: 16px;
      }
    }  
  }
`;
